(async () => {
    const { Core } = await importModule('Core');
    const { Swiper } = await importModule('Swiper');

    const ATTR_INITIAL_POSITION = 'initial-image-position';

    customElements.define('product-gallery', class extends Core {
        elements = {
            swiper: '[data-swiper]',
            pagination: '[data-pagination]'
        }

        subscriptions = {
            'variant:update': '_onVariantChange'
        }

        render() {
            this._initSwiper();
            this.subscribe('variant:update');
            // Warm the remaining gallery automatically after the main image arrives.
            const first = this.swiper.slides[this.swiper.activeIndex]?.querySelector('img');
            const warm = () => { if (this.isConnected) this.swiper.slides.forEach((_, i) => this._loadImage(i)); };
            if (first?.complete) warm();
            else first?.addEventListener('load', warm, { once: true });
        }

        _initSwiper() {
            this.swiper = new Swiper(this.$swiper, {
                autoHeight: true,
                initialSlide: Math.max(0, +this.initialPosition - 1),
                pagination: {
                    el: this.$pagination,
                    type: 'bullets'
                },
                breakpoints: {
                    992: {
                        allowTouchMove: false
                    }
                }
            });
            this._loadNearby();
            this.swiper.on('slideChange', () => this._loadNearby());
            const prev = this.querySelector('[data-gallery-prev]');
            const next = this.querySelector('[data-gallery-next]');
            const syncAccessibility = () => {
                this.swiper.slides.forEach((slide, index) => {
                    const inactive = index !== this.swiper.activeIndex;
                    if (inactive && slide.contains(document.activeElement)) {
                        const control = [next, prev].find(button => button && button.getClientRects().length);
                        if (control) control.focus({ preventScroll: true });
                        else {
                            this.setAttribute('tabindex', '-1');
                            this.focus({ preventScroll: true });
                        }
                    }
                    slide.inert = inactive;
                    slide.setAttribute('aria-hidden', String(inactive));
                });
                if (prev) { prev.disabled = false; prev.setAttribute('aria-disabled', String(this.swiper.isBeginning)); }
                if (next) { next.disabled = false; next.setAttribute('aria-disabled', String(this.swiper.isEnd)); }
            };
            prev?.addEventListener('click', () => { if (!this.swiper.isBeginning) this.showSlide(this.swiper.activeIndex - 1); });
            next?.addEventListener('click', () => { if (!this.swiper.isEnd) this.showSlide(this.swiper.activeIndex + 1); });
            this.swiper.on('slideChange', syncAccessibility);
            syncAccessibility();
        }

        _onVariantChange(data) {
            if(data?.imagePosition) {
                this.showSlide(data.imagePosition - 1);
            }
        }

        _loadImage(index) {
            const slide = this.swiper.slides[index];
            const template = slide?.querySelector('template[data-gallery-image]');
            if (template) {
                template.replaceWith(template.content.cloneNode(true));
                slide.querySelectorAll('img').forEach(image => { image.loading = 'eager'; image.fetchPriority = 'low'; });
            }
            return slide?.querySelector('img');
        }

        _loadNearby() {
            const index = this.swiper.activeIndex;
            [index, index - 1, index + 1].forEach(i => this._loadImage(i));
        }

        async showSlide(index) {
            const request = this._slideRequest = (this._slideRequest || 0) + 1;
            const image = this._loadImage(index);
            if (image) {
                image.fetchPriority = 'high';
                try { await image.decode(); } catch (_) {}
            }
            if (request === this._slideRequest) this.swiper.slideTo(index);
        }

        get slider() {
            return this.swiper;
        }

        get initialPosition() {
            return this.getAttribute(ATTR_INITIAL_POSITION)
        }
    })
})();
